<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--返回-->
                    <div style="padding-bottom: 20px">
                        <el-button class="mybtn-ret" @click="xTo({path:'/purchase/plan'})">返回</el-button>
                    </div>

                    <div v-loading="detail_loading">

                        <!--标题区-->
                        <div class="plan-detail-title">
                            <div class="main-title">采购单详情</div>
                            <div class="sub-title">采购单号：{{detail.cgdNo}}</div>
                            <div class="sub-title">仓库名称：{{detail.whName}}</div>
                        </div>

                        <!--表格、分页-->
                        <el-table :data="detail_list" size="medium">
                            <el-table-column prop="goodsName" label="商品名称" width="260" align="center" header-align="center"> </el-table-column>
                            <el-table-column prop="barcode" label="条码货号" width="260" align="center" header-align="center"> </el-table-column>
                            <el-table-column prop="skuVname" label="规格" width="200" align="center" header-align="center"> </el-table-column>
                            <el-table-column prop="unitName" label="单位" width="200" align="center" header-align="center"> </el-table-column>
                            <el-table-column prop="stocks" label="采购数量" align="center" header-align="center"> </el-table-column>
                        </el-table>

                        <!--操作-->
                        <div style="margin: 70px 0 150px 0">
                            <span style="font-size: 16px;color:#303133">审批意见：</span>
                            <span v-if="detail.states == 1">
                                <el-button class="mybtn-green" style="width: 100px;margin-left: 20px" @click="audit(true)" plain>通过</el-button>
                                <el-button class="mybtn-red" style="width: 100px;margin-left: 20px" @click="audit(false)" plain>不通过</el-button>
                            </span>
                            <span v-if="detail.states == 6" style="font-size: 16px">待入库</span>
                            <span v-if="detail.states == 99" style="font-size: 16px">已完成</span>
                        </div>

                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            id: null,
            // 详情
            detail_loading: false,
            detail: {},
            detail_list: []
        }
    },
    methods:{
        audit: function (bol) {
            let self = this
            let states = bol ? '6' : '1'

            self.xEui.confirm('提示', '确认要执行该操作吗？', function () {
                self.postAudit(self.id, states, function () {
                    self.$set(self.detail, 'states', states)
                })
            })
        },
        postAudit: function (id, states/*1不通过 6通过*/,cb) {
            let self = this
            self.xEui.myloading('审核中...')
            self.xFetch.post(self.xApi('/robot/purchase/audit'), {
                id: id,
                states: states
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('审核完成')
                    cb && cb();
                }
            });
        }
    },
    created: function(){
      let self = this

      // check id
      self.id = self.$route.query.id;
      if (!self.id) {
        self.xTo({path: '/purchase/plan'})
        return;
      }

      // 加载详情
      self.detail_loading = true
      self.xFetch.post(self.xApi('/robot/purchase/getDetails'), {
        id: self.id
      },{xPostType:'form'}).then(function (res) {
        self.detail_loading = false

        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          self.xTo({path: '/purchase/plan'})
          return
        }
        self.detail = res.data.data;
        self.detail_list = res.data.data.list;
      });
    },
    // keep-alive事件
    activated: function(){
        let self = this

        // check id
        self.id = self.$route.query.id;
        if (!self.id) {
            self.xTo({path: '/purchase/plan'})
            return;
        }

        // 加载详情
        self.detail_loading = true
        self.xFetch.post(self.xApi('/robot/purchase/getDetails'), {
            id: self.id
        },{xPostType:'form'}).then(function (res) {
            self.detail_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                self.xTo({path: '/purchase/plan'})
                return
            }
            self.detail = res.data.data;
            self.detail_list = res.data.data.list;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*plan-detail-title*/
    .plan-detail-title{ padding: 10px 0 }
    .plan-detail-title .main-title{ font-size: 16px;color: #303133;text-align: center;font-weight: 700;padding-bottom: 40px }
    .plan-detail-title .sub-title{ font-size: 14px; color: #303133;}
</style>



// WEBPACK FOOTER //
// src/views/purchase/plan-detail.vue